import React from 'react'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import EDSContainer from '../../Containers/EDSContainer'

const EDS = () => {
	const { t } = useTranslation()

	return (
		<>
			<Helmet>
				<meta charSet='utf-8' />
				<title>
					{t('st:head.menu')} | {t('st:head.appTitle')}
				</title>
			</Helmet>
			<EDSContainer />
		</>
	)
}

export default EDS
